/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { IPoint, registerEdge, IShape, INode } from '@antv/g6'
import { uniq } from 'lodash-es'
import { GraphStates } from './utils'
import { lineIntersectsRect } from './intersects'

const lineDash = [4]
// x轴是否要偏移来达到线减少重叠
const XOffsetFlag = false

// https://g6-v4.antv.vision/manual/middle/elements/edges/custom-edge
export function registerCustomNodeEdge(): void {
  registerEdge(
    'custom-edge',
    {
      setState(name, value, item) {
        const shape = item?.get<IShape>('keyShape')

        // 结束动画
        shape?.stopAnimate()
        // 清空 lineDash
        shape?.attr('lineDash', null)

        if (item?.hasState(GraphStates.Selected)) {
          shape?.attr(item?.getStateStyle(GraphStates.Selected))
        } else if (item?.hasState(GraphStates.Hover)) {
          shape?.attr(item?.getStateStyle(GraphStates.Hover))
        } else if (item?.hasState(GraphStates.Actived)) {
          let index = 0
          shape?.animate(
            () => {
              index++
              if (index > 9) {
                index = 0
              }
              const res = {
                ...item?.getStateStyle(GraphStates.Actived),
                lineDash,
                lineDashOffset: -index,
              }
              // 返回需要修改的参数集，这里修改了 lineDash,lineDashOffset
              return res
            },
            {
              repeat: true, // 动画重复
              duration: 3000, // 一次动画的时长为 3000
            },
          )
        } else if (item?.hasState(GraphStates.Highlight)) {
          shape?.attr(item?.getStateStyle(GraphStates.Highlight))
        } else {
          const style = item?.getModel().style
          style && shape?.attr(style)
        }
      },

      getControlPoints(cfg) {
        const { startPoint, endPoint } = cfg
        const sourceNode = this.mergeStyle?.sourceNode as INode | undefined
        const targetNode = this.mergeStyle?.targetNode as INode | undefined
        const nodeHeight = sourceNode?.getBBox().height ?? 0
        const neighbors = [
          ...(sourceNode?.getNeighbors() ?? []),
          ...(targetNode?.getNeighbors() ?? []),
        ]

        if (startPoint && endPoint) {
          const oldControlPoints = cfg.controlPoints as IPoint[] | undefined
          const needOffset =
            oldControlPoints &&
            oldControlPoints.length > 1 &&
            uniq(oldControlPoints.map((p) => p.y)).length === 1

          // const offsetValue = 5 * (oldControlPoints?.length ?? 0)
          const targetNodes = sourceNode
            ?.getEdges()
            .map((edge) => edge.getTarget())
            .filter((t) =>
              Boolean(t.getBBox && typeof t.getBBox === 'function'),
            )
            .sort((n1, n2) => n2.getBBox().y - n1.getBBox().y)

          const targetNodeOrderIndex =
            targetNodes?.findIndex((n) => n.getID() === targetNode?.getID()) ??
            0
          const baseMin = 20
          const orderIndexByY =
            targetNodeOrderIndex === -1 ? 0 : targetNodeOrderIndex
          const _xOffset = XOffsetFlag ? baseMin * orderIndexByY : 0

          const distance = endPoint.x - startPoint.x

          const offset = Math.min(baseMin + _xOffset, (distance / 2) * 0.9)
          const y = Math.max(startPoint.y, endPoint.y)

          const startX = startPoint.x + offset
          const endX = endPoint.x - offset
          let midPoints: IPoint[] = []
          // const shouldBottom =
          //   !cfg.basePath &&
          //   startPoint.y > endPoint.y &&
          //   startPoint.y - endPoint.y > 100

          // console.log(
          //   'aaa shouldBottom',
          //   shouldBottom,
          //   startPoint.y > endPoint.y,
          //   startPoint.y - endPoint.y,
          // )
          if (
            needOffset
            // &&
            // !shouldBottom
          ) {
            const _yOffsetDir = startPoint.y <= endPoint.y ? 1 : -1
            const _yOffset = 8 * oldControlPoints.length // * 1.5 + 12

            const _y = endPoint.y + _yOffset * _yOffsetDir

            // 检测线是否穿过节点
            const isIntersects = neighbors.some((n) => {
              const box = n.getBBox()
              return lineIntersectsRect(
                startX,
                _y,
                endX,
                _y,
                box.minX,
                box.minY,
                box.maxX,
                box.maxY,
              )
            })

            const y = isIntersects
              ? _y + (nodeHeight / 2 + 8) * _yOffsetDir
              : _y
            midPoints = [
              {
                x: startX,
                y: y,
              },
              {
                x: endX,
                y: y,
              },
            ]
          } else {
            if (startPoint.y === endPoint.y) {
              // 检测线是否穿过节点
              const edgesLength = sourceNode?.getOutEdges().length ?? 0
              const throughNodes = neighbors.filter((n) => {
                if (!(n.getBBox && typeof n.getBBox === 'function')) {
                  return false
                }

                const box = n.getBBox()
                return lineIntersectsRect(
                  startX,
                  startPoint.y,
                  endX,
                  endPoint.y,
                  box.minX,
                  box.minY,
                  box.maxX,
                  box.maxY,
                )
              })

              if (throughNodes.length > 0) {
                const offsetLen = Math.max(edgesLength, throughNodes.length)

                const afterY = y + nodeHeight / 2 + 8 * offsetLen
                midPoints = [
                  {
                    x: startX,
                    y: afterY,
                  },
                  {
                    x: endX,
                    y: afterY,
                  },
                ]
              }
            } else {
              midPoints =
                y === startPoint.y
                  ? [
                      /* { x: endX, y },*/
                      { x: startX, y: endPoint.y },
                    ]
                  : [{ x: startX, y }]
            }
          }

          if (startPoint.x > endPoint.x) {
            const _midYBase = Math.min((startPoint.y, endPoint.y))

            const dir = startPoint.y > endPoint.y ? 1 : -1

            const midY =
              _midYBase +
              Math.max(
                nodeHeight / 2 + baseMin,
                Math.abs((startPoint.y - endPoint.y) / 2),
              ) *
                dir

            return [
              {
                x: startPoint.x + 20,
                y: startPoint.y,
              },
              {
                x: startPoint.x + 20,
                y: midY,
              },

              {
                x: endPoint.x - 20,
                y: midY,
              },
              {
                x: endPoint.x - 20,
                y: endPoint.y,
              },
            ]
          }

          return [
            {
              x: startX,
              y: startPoint.y,
            },
            ...midPoints,
            {
              x: endX,
              y: endPoint.y,
            },
          ]
        }

        return []
      },
    },
    'polyline',
  )
}
